import { Divider, Row, SizedBox } from "../CommonBaseComponents";
import { C3Text } from "./CustomText";
import CustomIcon from "../image/CustomIcon";
import { Theme } from "../../Theme";

export const DividerTextRow = ({ alignItem = "center", height = "16px", items }) => {
    return (
        <Row alignItem={alignItem} height={height}>
            {items.map((item, index) => (
                <>
                    {item.icon !== undefined && (
                        <>
                            <CustomIcon iconName={item.icon} size={"18px"} />
                            <SizedBox width={item.iconGap ?? "8px"} />
                        </>
                    )}
                    {item.label !== undefined && (
                        <>
                            <C3Text fontColor={Theme.color.gray500}>{item?.label}</C3Text>
                            <SizedBox width={"6px"} />
                        </>
                    )}

                    <C3Text fontColor={Theme.color.gray500}>{item?.value}</C3Text>
                    {index !== items.length - 1 && (
                        <Divider orientation={"vertical"} height={"16px"} marginLeft={"8px"} marginRight={"8px"} />
                    )}
                </>
            ))}
        </Row>
    );
};

export default DividerTextRow;
